import { gql } from "graphql-request";

export const ADMIN_CREATE_ARTICLE = gql`
  mutation AdminCreateArticle($input: AdminCreateArticleInputDto!) {
    adminCreateArticle(input: $input) {
      success
      article {
        _id
        type
        title {
          ko
          en
        }
        createdAt
      }
    }
  }
`;

export const ADMIN_UPDATE_ARTICLE = gql`
  mutation AdminUpdateArticle($input: AdminUpdateArticleInputDto!) {
    adminUpdateArticle(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_PUBLISH_ARTICLE = gql`
  mutation AdminPublishArticle($articleId: String!) {
    adminPublishArticle(articleId: $articleId) {
      success
      message
    }
  }
`;

export const ADMIN_UNPUBLISH_ARTICLE = gql`
  mutation AdminUnpublishArticle($articleId: String!) {
    adminUnpublishArticle(articleId: $articleId) {
      success
      message
    }
  }
`;

export const ADMIN_DELETE_ARTICLE = gql`
  mutation AdminDeleteArticle($articleId: String!) {
    adminDeleteArticle(articleId: $articleId) {
      success
      message
    }
  }
`;

export const ADMIN_CREATE_ARTICLE_FROM_FILE = gql`
  mutation AdminCreateArticleFromFile($input: AdminCreateArticleFromFileInputDto!) {
    adminCreateArticleFromFile(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_UPDATE_ARTICLE_META = gql`
  mutation AdminUpdateArticleMeta($input: AdminUpdateArticleMetaInputDto!) {
    adminUpdateArticleMeta(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_SYNC_ARTICLE_CONTENT = gql`
  mutation AdminSyncArticleContent($input: AdminSyncArticleContentInputDto!) {
    adminSyncArticleContent(input: $input) {
      success
      message
    }
  }
`;
